import type {MobileAuthedWebviewEntryPointConfig} from '../ConnectElementList';

export const EditPayoutDestinationConfig: MobileAuthedWebviewEntryPointConfig =
  {
    Component: () =>
      import(
        /* webpackChunkName: "EditPayoutDestination" */
        '../../../components/Account/PayoutInformation/PayoutSchedule/EditPayoutDestinationEntryPoint'
      ),
    description: 'Mobile authed webview entry point to edit payout destination',
    friendlyName: 'Mobile entry point: edit payout destination',
  };
